import {Component} from 'react';
import PropTypes from 'prop-types';

import {trackingEventsService} from '_app/services';
import {Enums} from '_app/utils';

// wrapper around JWPlayer
export default class VideoPlayer extends Component {
	static propTypes = {
		options: PropTypes.shape({
			file: PropTypes.string.isRequired,
			mediaid: PropTypes.string.isRequired,
			image: PropTypes.string,
			tracks: PropTypes.array,
			logo: PropTypes.object
		}).isRequired,
		token: PropTypes.string
	}

	componentDidMount() {
		this.initialize();
	}

	componentDidUpdate(prevProps) {
		if (this.props.options !== prevProps.options) {
			this.initialize();
		}
	}

	componentWillUnmount() {
		this.eventsRemove();
	}

	delayID = null

	eventsAdd(player, token) {
		player.on('ready', function() {
			player.play(false);
		});

		if (token) {
			const eventTypes = Enums.getType('eventTypes');

			player.on('firstFrame', function() {
				trackingEventsService.add(token, eventTypes.VIDEO_START);
			});
			player.on('complete', function() {
				trackingEventsService.add(token, eventTypes.VIDEO_COMPLETE);
			});
		}
	}

	eventsRemove() {
		if (this.player) {
			this.player.off('complete');
			this.player.off('firstFrame');
			this.player.stop();
		}
		window.clearTimeout(this.delayID);
	}

	initialize() {
		if (!this.container) {
			return;
		}
		const {jwplayer} = window;
		const player = jwplayer(this.container.id)
			.setup(this.props.options);

		this.eventsAdd(player, this.props.token);
		this.player = player;
	}

	initRef = el => {
		this.container = el;
	}

	render() {
		return <div id="video-player" ref={this.initRef} />;
	}
}